console.log('Loaded theme JS!');

function setCookieBanner(c_name, value, exdays) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate() + exdays);
	var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
	document.cookie = c_name + "=" + c_value;
}

// If user is not in Europe, force optanon closure by creating the cookie manually
var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
var isEurope = timeZone.indexOf('Europe') != -1;
// console.log(isEurope);
$(document).ready(function () {
	if (isEurope) {
		//console.log("In Europe!");
	} else {
		//console.log("Not in Europe. Setting up cookie for 1 year");
		//setCookieBanner('OptanonAlertBoxClosed', true, 365); // 1 year
	}

	// Supremacy hook title only for Rhetoric
	var supremacy_node_title = jQuery('.page-node-type-supremacy h1.a-header--page-title').text();
	var supremacy_rhetoric_original = jQuery('.page-node-type-supremacy .m-report__rhetoric h2').text();
	jQuery('.page-node-type-supremacy .m-report__rhetoric h2').text(supremacy_node_title + supremacy_rhetoric_original);
});

/**
 * NodeList.forEach() polyfill for Internet Explorer
 */

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 * Add Timeline Script and Styles if #timeline-embed on page
 */

jQuery('document').ready(function ($) {
	//SVG Polyfill for IE11
	svg4everybody();
	// Weird to include this, but it gets CookiePro to actually work.
	window.jQuery = window.$ = jQuery;
	const timelines = document.querySelectorAll('#timeline-embed');
	if (timelines.length > 0) {
		jQuery.getScript(
			'/themes/custom/cep/libraries/timelinejs/build/js/storyjs-embed.js'
		);
		jQuery('head').append(
			'<link rel="stylesheet" href="/themes/custom/cep/libraries/timelinejs/build/css/timeline.css" type="text/css" />'
		);
	}
	//alert('Your Message');
});

// Add Class to Invalid Form Fields
if(document.addEventListener){
    document.addEventListener('invalid', function(e){
        e.target.className += ' invalid';
    }, true);
}

jQuery(document).ready(function ($) {
	jQuery(document).on('dialogopen', function (e, ui) {
		var uiOverlay = jQuery('.ui-widget-overlay');
		var drupalModal = jQuery('#drupal-modal')
		var isOpen = drupalModal.dialog('isOpen');
		if (isOpen) {
			uiOverlay.click(function (e) {
				drupalModal.dialog('close');
			});
		}
	});
	/* Donation Popup script */

  // Donation Submit function
  /* eslint-disable no-var */
  /* eslint-disable no-alert */
  /* eslint-disable indent */
  /* eslint-disable eqeqeq */
  const donationSubmitButtons = document.querySelectorAll('.donation-submit');
  const donationRecurring = document.getElementById('donation-recurring');
  const donations = document.querySelectorAll('.donation_value');

  // Loop through each submit button.
  donationSubmitButtons.forEach((curDonSubmit) => {

    curDonSubmit.addEventListener('click', function(e) {
      e.preventDefault();

      let revvUrl = 'https://counter-extremism-project.revv.co/giving-copy-01f668c7a6b86ab7?';
      let paypalUrl = 'https://www.paypal.com/donate?business=gbueno%40counterextremism.com&item_name=Counter+Extremism&item_number=Paypal&currency_code=USD&no_recurring=0&';
      let amount = false;
      let amountOther = false;

      // Is this recurring?
      if (donationRecurring.checked) {
        revvUrl += 'recurring=true&';
        // Turns out his option is to only make the recurring option show
        // up in paypal.
        //paypalUrl += 'no_recurring=1&';
      } else {
        revvUrl += 'recurring=false&';
        //paypalUrl += 'no_recurring=0&';
      }

      for ( let i = 0; i < donations.length; i++ ) {
        if (donations[ i ].classList.contains('selected')) {
          amount = donations[ i ].getAttribute('data-value');
          //alert(amount + amountOther);
          if (donations[ i ].getAttribute('data-value') == 0) {
            amountOther = true;
          }
        }
      }

      console.log('amount',amount);
      if (amount) {

        // Clear amount if amount other is set.
        if (amountOther) {
          amount = false;
        }

        // Add amount to url.
        if (amount) {
          revvUrl += 'amount=' + amount;
          paypalUrl += 'amount=' + amount;
        } else {
          revvUrl += 'amount=250';
          paypalUrl += 'amount=0';
        }

        // Load the correct url.
        let redirectUrl = revvUrl
        if (this.id === 'donation-submit-paypal') {
          redirectUrl = paypalUrl;
        }

        window.open(redirectUrl, '_blank');
      } else {
        alert('Please select a donation amount');
        return false;
      }
    });
  });

	// Donation mark selected
	jQuery("#donation-prices .donation_value").click(function (e) {
		e.preventDefault();
		jQuery('.donation_value').removeClass('selected');
		jQuery(this).addClass('selected');
	});

	// tabs on content/terms-service page
	jQuery("#tab-sm").click(function (e) {
		e.preventDefault();
		jQuery(".tab-container").hide();
		jQuery(".tab-container").removeClass("selected");
		jQuery(".tab-1-container").show();
		jQuery(".tab-1-container").addClass("selected");

		jQuery(".ts-tabs-container .tab-link").removeClass("selected");
		jQuery(this).addClass("selected");
	});
	// tab2
	jQuery("#tab-msa").click(function (e) {
		e.preventDefault();
		jQuery(".tab-container").hide();
		jQuery(".tab-container").removeClass("selected");
		jQuery(".tab-2-container").show();
		jQuery(".tab-2-container").addClass("selected");

		jQuery(".ts-tabs-container .tab-link").removeClass("selected");
		jQuery(this).addClass("selected");
	});
	// tab3
	jQuery("#tab-sp").click(function (e) {
		e.preventDefault();
		jQuery(".tab-container").hide();
		jQuery(".tab-container").removeClass("selected");
		jQuery(".tab-3-container").show();
		jQuery(".tab-3-container").addClass("selected");

		jQuery(".ts-tabs-container .tab-link").removeClass("selected");
		jQuery(this).addClass("selected");
	});
	// tab4
	jQuery("#tab-vh").click(function (e) {
		e.preventDefault();
		jQuery(".tab-container").hide();
		jQuery(".tab-container").removeClass("selected");
		jQuery(".tab-4-container").show();
		jQuery(".tab-4-container").addClass("selected");

		jQuery(".ts-tabs-container .tab-link").removeClass("selected");
		jQuery(this).addClass("selected");
	});
	// tab5
	jQuery("#tab-other").click(function (e) {
		e.preventDefault();
		jQuery(".tab-container").hide();
		jQuery(".tab-container").removeClass("selected");
		jQuery(".tab-5-container").show();
		jQuery(".tab-5-container").addClass("selected");

		jQuery(".ts-tabs-container .tab-link").removeClass("selected");
		jQuery(this).addClass("selected");
	});
	// tab6
	jQuery("#tab-wwd").click(function (e) {
		e.preventDefault();
		jQuery(".tab-container").hide();
		jQuery(".tab-container").removeClass("selected");
		jQuery(".tab-6-container").show();
		jQuery(".tab-6-container").addClass("selected");
		jQuery(".ts-tabs-container .tab-link").removeClass("selected");
		jQuery(this).addClass("selected");
	});

	jQuery(".j-filtertoggle").click(function (e) {
		e.preventDefault();
		jQuery(".j-filtertoggle").toggleClass("j-active");
	});

});

// Sticky Header
window.onload = function () { stickyHeader() };
window.onresize = function () { stickyHeaderUpdate() };
// window.onscroll = function() {stickyHeader()}; no needed?
window.addEventListener('scroll', stickyHeaderUpdate);
window.addEventListener('resize', stickyHeaderUpdate);
// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickyHeader() {
	setTimeout(function () {
		// Get the header
		var st_body = document.body;
		var st_header = document.getElementById('c-micro-site-header');
		if (st_header) {
			var st_headerHeight = st_header.offsetHeight;

			// Get the offset position of the navbar
			var st_sticky = st_header.offsetTop;

			if (st_header.classList.contains("is-sticky")) {
				st_body.classList.add("is-sticky");
				if (window.pageYOffset > st_sticky) {
					st_body.style.padding = st_headerHeight + "px 0 0 0";
					st_header.classList.add("is-on");
				} else {
					st_body.style.padding = "0";
					st_header.classList.remove("is-on");
				}
			}
		}
	}, 500);
}

function stickyHeaderUpdate() {
	// Get the header
	var st_body = document.body;
	var st_header = document.getElementById('c-micro-site-header');
	if (st_header) {
		var st_headerHeight = st_header.offsetHeight;

		// Get the offset position of the navbar
		var st_sticky = st_header.offsetTop;

		if (st_header.classList.contains("is-sticky")) {
			st_body.classList.add("is-sticky");
			if (window.pageYOffset > st_sticky) {
				st_body.style.padding = st_headerHeight + "px 0 0 0";
				st_header.classList.add("is-on");
			} else {
				st_body.style.padding = "0";
				st_header.classList.remove("is-on");
			}
		}
	}

}
